import { uploadData, getUrl } from "aws-amplify/storage";
import { recordSentry } from "utils/recordSentry";

export async function handleUploadToS3(url: string, stringifiedJson: string, onProgressCb?: (e: any) => void) {
	try {
		await uploadData({
			key: url,
			// Alternatively, path: ({identityId}) => `protected/${identityId}/album/2024/1.jpg`
			data: stringifiedJson,
			options: {
				onProgress: onProgressCb, // Optional progress callback.
			},
		}).result;
	} catch (error) {
		const message = "ERROR SAVING JSON TO S3 BUCKET";
		recordSentry({ error, msg: message });
	}
}

export async function verifyUpload(url: string): Promise<boolean> {
	try {
		// Attempt to retrieve the file's URL
		await getUrl({
			key: url,
			options: {
				validateObjectExistence: true, // Ensure the method validates existence
			},
		});
		return true; // File exists
	} catch (error: any) {
		if (error.name === "NoSuchKey" || error.name === "NotFound") {
			return false; // File does not exist
		}
		// Log unexpected errors
		recordSentry({ error, msg: "Error checking file existence in S3" });
		throw error;
	}
}
